<template>
  <div>
    <div class="thisTitle">
      <span class="thisIcon">
        <img src="../../common/images/icon-jifenlogo.png" alt=""/>
      </span>
      <span>积分</span>
    </div>
    <div class="JiFenWrap">
      <el-table :data="scoreArr" class="filterTable" size="small" border style="width: 100%" v-loading="loading">
        <el-table-column type="index" label="编号" width="50" align="center"></el-table-column>
        <el-table-column prop="masterName" label="指标" align="center"></el-table-column>
        <el-table-column prop="score" label="分数" align="center"></el-table-column>
      </el-table>
    </div>

  </div>
</template>

<script>
  //韩金辰180723重写
  export default {
    name: 'zScore',
    data() {
      return {
        scoreArr: [],
        loading: false,
      }
    },
    mounted() {
      this.loading = true
      this.$http({
        method: "get",
        url: '/rest/ScoreSystemSettings/searchScore',
        params: {
          startTime: this.$route.query.sTime,
          scoreType: 1
        }
      }).then(res => {
        this.scoreArr = res.data
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
  }
</script>

<style scoped lang="scss">
  .thisTitle {
    span:last-child {
      font-size: 15px;
      vertical-align: middle;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .thisIcon {
      width: 20px;
      height: 20px;
      display: inline-block;
      vertical-align: middle;
      border-radius: 50%;
      margin-right: 10px;
    }
  }

  .JiFenWrap {
    background-color: white;
    padding: 20px;
    margin: 15px 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/Assessment/zScore.vue